import api from './client';

// Creator-side endpoints ------------------------------------------------------
export const getCreatorBillingProfile = async () => {
  const res = await api.get('/creator/billing-profile');
  return res.data;
};

export const updateCreatorFiscal = async (patch) => {
  const res = await api.put('/creator/billing-profile/fiscal', patch);
  return res.data;
};

export const syncCreatorBilling = async () => {
  const res = await api.post('/creator/billing-profile/sync');
  return res.data;
};

// Admin-side endpoints --------------------------------------------------------
export const adminGetCreatorBillingProfile = async (userId) => {
  const res = await api.get(`/admin/creators/${userId}/billing-profile`);
  return res.data;
};

export const adminRefreshCreatorBilling = async (userId) => {
  const res = await api.post(`/admin/creators/${userId}/billing-profile/refresh`);
  return res.data;
};

export const adminGetStripeDashboardLink = async (userId) => {
  const res = await api.post(`/admin/creators/${userId}/billing-profile/dashboard-link`);
  return res.data;
};

export const adminResendOnboardingLink = async (userId) => {
  const res = await api.post(`/admin/creators/${userId}/billing-profile/resend-onboarding`);
  return res.data;
};
